export class CustomReconnectPolicy {
    nextRetryDelayInMilliseconds(_retryContext: any) {
        return 10000 // Retry every 5 seconds indefinitely
    }
}